module.exports = __webpack_public_path__ + "img/07陈真.6aa31b36.png";